import { Component, OnInit } from "@angular/core";
import { getApp } from "../../app";

@Component({
  selector: "app-filter-dashboard",
  templateUrl: "./filter-dashboard.component.html",
  styleUrls: ["./filter-dashboard.component.scss"],
})
export class FilterDashboardComponent implements OnInit {
  createTimeStart: string = "";

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit() {}
}
